import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { WidgetPreferenceService } from './services/widget-preference.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent {
  widgetsToShow: any[] = [];

  constructor(private widgetPreferenceService: WidgetPreferenceService) {
    this.loadWidgets();
  }

  loadWidgets() {
    const preferences = this.widgetPreferenceService.getUserPreferences();
    const availableWidgets = this.widgetPreferenceService.getAvailableWidgets();

    this.widgetsToShow = preferences
      .map((id) => availableWidgets.find((widget) => widget.id === id))
      .filter((widget) => widget);
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.widgetsToShow, event.previousIndex, event.currentIndex);

    // Gem rækkefølgen i brugerpræferencerne
    const newPreferences = this.widgetsToShow.map((widget) => widget.id);
    this.widgetPreferenceService.setUserPreferences(newPreferences);
  }
}
